import { ModelVuexDB } from "@/models/ModelVuexDB";
import ApiQueue from "@/libraries/ApiQueue";
import { getNow } from "@/helpers/format_date";
export class SiteModel extends ModelVuexDB {
    static onSuccessSubmit(CLASS_NAME, response) {
        response.synchronizating = false;
        response.sync_time = +getNow();
        response.last_update_time = +getNow();
        const m = new window[CLASS_NAME](response.id);
        m.setData(response);
        m.setDataToDB(response.was_id);
    }
    async getDataToSend() {
        return this.getData();
    }
    async flush(CLASS_NAME, API_URI) {
        const isFlushed = super.flush();
        if (!isFlushed) {
            return;
        }
        this.synchronizating = true;
        const data = await this.getDataToSend();
        const response = await ApiQueue.patch(`${API_URI}/${this.id}`, Object.assign({ 'is_set': true }, data), ApiQueue.REPEAT_UNTIL_SUCCESS + ApiQueue.REPLACE_EQUAL + ApiQueue.HIGH_PRIORITY, `${CLASS_NAME}.onSuccessSubmit`);
        window[CLASS_NAME].onSuccessSubmit(response);
    }
    __get(target, prop, receiver) {
        var _a, _b;
        if (prop === 'synchronizating') {
            return (_a = target.data[prop]) !== null && _a !== void 0 ? _a : false;
        }
        if (prop === 'sync_time') {
            return (_b = target.data[prop]) !== null && _b !== void 0 ? _b : false;
        }
        return super.__get(target, prop, receiver);
    }
    __set(target, prop, value, receiver) {
        if (prop === 'synchronizating') {
            return target.data[prop] = value;
        }
        if (prop === 'sync_time') {
            return target.data[prop] = value;
        }
        return super.__set(target, prop, value, receiver);
    }
}
